import * as React from 'react';
import { Route, Redirect, RouteProps, withRouter } from 'react-router';
import { IRootProps } from '../../components/RootProps';

import * as tradeInRoutes from '../../utils/routes';
import VehicleInfo from './vehicleInfo/VehicleInfo';
import TradeInDecision from './decisionPage/TradeInDecision';
import ManualEntry from './manualEntry/ManualEntry';
import TradeInSummary from './summary/Summary';
import VehicleCondition from './vehicleCondition/VehicleCondition';
import EquipmentOptionsStepOne from './equipmentOptions/EquipmentOptionsStepOne';
import EquipmentOptions from './equipmentOptions/EquipmentOptions';
import LoanBalance from './loanBalance/LoanBalance';
import EstimateLoanBalance from './EstimateLoanBalance/EstimateLoanBalance';
import LoanBalanceOptions from './loanBalanceOptions/LoanBalanceOptions';
import RegistrationDetails from './registrationDetails/RegistrationDetails';
import FindOpenLoan from './findOpenLoan/FindOpenLoan';
import LoanConfirmation from './loanConfirmation/LoanConfirmation';
import AutoLoanUnavailable from './autoLoanUnavailable/AutoLoanUnavailable';
import TradeInIco from './icoValuation/IcoValuation';
import { PropsRoute } from '@makemydeal/dr-activities-common';
import { useStepChange } from '../hooks/useStepChange';

const TradeInRouting: React.FC<IRootProps & RouteProps> = (props) => {
    const { currentRoute, isCompleted, selector, location, onStepChange } = props;

    useStepChange(location.pathname, onStepChange);

    const getRedirectionRoute = () => {
        if (!isCompleted) {
            return currentRoute;
        }

        return tradeInRoutes.TRADE_SUMMARY;
    };

    return (
        <div className="dr-p202-trade-in">
            <Route path={tradeInRoutes.TRADE_IN} render={() => <Redirect to={getRedirectionRoute()} />} />
            <Route path={tradeInRoutes.TRADE_IN_SEARCH} render={() => <Redirect to={getRedirectionRoute()} />} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_VEHICLE_INFO} component={VehicleInfo} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_IN_EXTERNAL} component={VehicleInfo} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_VEHICLE_CONDITION} component={VehicleCondition} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_EQUIPMENT_OPTIONS} component={EquipmentOptions} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_EQUIPMENT_OPTIONS_STEP_ONE} component={EquipmentOptionsStepOne} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_LOAN_BALANCE} component={LoanBalance} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE} component={EstimateLoanBalance} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_LOAN_BALANCE_OPTIONS} component={LoanBalanceOptions} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_REGISTRATION_DETAILS} component={RegistrationDetails} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_FIND_OPEN_LOAN} component={FindOpenLoan} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_LOAN_CONFIRMATION} component={LoanConfirmation} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_AUTO_LOAN_UNAVAILABLE} component={AutoLoanUnavailable} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_IN_DECISION} component={TradeInDecision} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_MANUAL_ENTRY} component={ManualEntry} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_SUMMARY} component={TradeInSummary} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_IN_ICO} component={TradeInIco} />
            <PropsRoute {...props} path={tradeInRoutes.TRADE_SUBARU_ELIGIBILITY} component={VehicleInfo} />
        </div>
    );
};

export { TradeInRouting };
export default withRouter(TradeInRouting as any);
